import toastr from 'toastr';
import { ChartMarkLineInterface } from '../../chart/candlestick-chart.component';
import { SharedAnalysisInterface } from '../../../ng-services/social-trading/analysis-sharing.store';

export class AnalysisSharingTableRowDetailsComponent {
    trade!: SharedAnalysisInterface;

    setupText = '';
    markLines!: ChartMarkLineInterface[];

    $onInit() {
        this.setupText = this.trade.posts?.[0].content;
    }

    copy() {
        navigator.clipboard.writeText(this.setupText).then(
            () => toastr.success('Setup Text copied to clipboard'),
            () => toastr.error('Clipboard error')
        );
    }
}

angular.module('tradersyard').component('tyAnalysisSharingTableRowDetailsComponent', {
    // language=HTML
    template: `
        <div class="row">
            <div class="col-sm-12 col-md-4">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="panel panel-default description_panel">
                            <div class="panel-heading">
                                <h3 class="panel-title">Setup Text</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="wrapper">
                                            <pre><code>{{$ctrl.setupText}}</code></pre>
                                        </div>
                                    </div>
                                    <div class="col-sm-1">
                                        <button ng-click="$ctrl.copy()" class="btn btn-default">Copy to clipboard</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-8">
                <ty-candlestick-chart symbol="$ctrl.trade.symbol" mark-lines="$ctrl.markLines"/>
            </div>
        </div>
    `,
    controller: AnalysisSharingTableRowDetailsComponent,
    bindings: {
        trade: '<',
    },
});
